var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4488_5121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9596 34.3945H12.043C8.52822 34.3945 5.66797 31.5343 5.66797 28.0195V6.76953C5.66797 3.25478 8.52822 0.394531 12.043 0.394531H21.9596C25.4744 0.394531 28.3346 3.25478 28.3346 6.76953V28.0195C28.3346 31.5343 25.4744 34.3945 21.9596 34.3945ZM12.043 1.8112C9.3088 1.8112 7.08464 4.03536 7.08464 6.76953V28.0195C7.08464 30.7537 9.3088 32.9779 12.043 32.9779H21.9596C24.6938 32.9779 26.918 30.7537 26.918 28.0195V6.76953C26.918 4.03536 24.6938 1.8112 21.9596 1.8112H12.043ZM19.8346 29.4362C19.8346 29.0452 19.5173 28.7279 19.1263 28.7279H14.8763C14.4853 28.7279 14.168 29.0452 14.168 29.4362C14.168 29.8272 14.4853 30.1445 14.8763 30.1445H19.1263C19.5173 30.1445 19.8346 29.8272 19.8346 29.4362Z",
    fill: "url(#paint0_linear_4488_5121)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4488_5121",
    x1: 2.36241,
    y1: -7.39714,
    x2: 37.256,
    y2: 20.0525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7410FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4488_5121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(0 0.394531)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.b91f910d975ea2ea662c5b787955832c.svg";
export { ForwardRef as ReactComponent };